// extracted by mini-css-extract-plugin
export default {"participantRow":"kDZOsmyTZnXCdPU8f1Q4","participant":"aaJteYarYFuFceVUdmxA","name":"tnvEI3w3eJjfEUtNgdap","role":"L6BWfuWHpgKB6yeBbwNM","audioStatus":"cGyRiGfpWShbRCRQKzsi"};